import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=390ea174&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"
import style0 from "./login-page.vue?vue&type=style&index=0&id=390ea174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ea174",
  null
  
)

export default component.exports